import { useState, useCallback, useMemo, useEffect } from 'react';
import { useQuery, useMutation } from '@ts-core/lib/apollo';
import isEmpty from 'lodash/isEmpty';

import { useMutationCompletionHandler } from '@ts-core/lib/apollo';
import { isValidEmail } from '@ts-core/utils/utils';

import { useGroups } from 'modules/groups/hooks';

import { searchStudentQuery } from '../../graphql/queries';
import { addStudentToCourseMutation } from '../../graphql/mutations';

export default function useAddStudentForm({ courseId, onStudentAdded }) {
  const { onError } = useMutationCompletionHandler();

  const [query, setQuery] = useState();
  const [student, setStudent] = useState();

  const { groups } = useGroups({ courseId });

  const { data, loading } = useQuery(searchStudentQuery, {
    variables: { query: encodeURIComponent(query) },
    skip: isEmpty(query),
  });

  const queryIsEmail = useMemo(() => isValidEmail(query), [query]);
  useEffect(() => {
    let result = data?.student;
    if (result && !result._id) {
      result = {
        personalId: queryIsEmail ? undefined : query,
        email: queryIsEmail ? query : undefined,
      };
    }
    setStudent(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryIsEmail, data]);

  const handleSearchStudent = useCallback((newQuery) => {
    setQuery(newQuery.replace(/\s/g, ''));
  }, []);

  const handleResetForm = useCallback(() => {
    setQuery();
    setStudent();
  }, []);

  /**
   * Add student to group
   */
  const [addStudentToCourse, { loading: addingStudentToCourse }] = useMutation(addStudentToCourseMutation, {
    onError,
    onCompleted: onStudentAdded,
  });
  const onAddStudentToCourse = useCallback(
    (input) => {
      addStudentToCourse({ variables: { courseId, input } });
    },
    [addStudentToCourse, courseId]
  );

  /**
   * Clean form
   */
  const onCleanForm = useCallback(() => {
    setQuery();
    setStudent();
  }, []);

  return {
    student,
    loading,
    query,
    submitting: addingStudentToCourse,
    groups,

    onSearchStudent: handleSearchStudent,
    onResetForm: handleResetForm,
    onAddStudent: onAddStudentToCourse,

    onCleanForm,
  };
}
